import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Residential', path: '/residential' },
    { name: 'Commercial', path: '/commercial' },
    { name: 'Financing', path: '/financing' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/24848c9e-ecf8-4995-b70c-f54ceefe879e.png"
              alt="BRICK CITY SOLAR, LLC"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-solar-blue'
                      : 'text-energy-yellow'
                    : isScrolled
                    ? 'text-gray-700 hover:text-solar-blue'
                    : 'text-white hover:text-energy-yellow'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:352-509-6933"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              <i className="ri-phone-line mr-2"></i>
              352-509-6933
            </a>
            <Link
              to="/contact"
              className="bg-energy-yellow text-solar-blue px-6 py-3 rounded-lg font-semibold text-sm hover:bg-yellow-400 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Free Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden text-2xl cursor-pointer ${
              isScrolled ? 'text-solar-blue' : 'text-white'
            }`}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="lg:hidden bg-white shadow-lg rounded-lg mt-2 py-4"
          >
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-6 py-3 text-sm font-medium ${
                  location.pathname === link.path
                    ? 'text-solar-blue bg-soft-gray'
                    : 'text-gray-700 hover:bg-soft-gray'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="px-6 py-3 space-y-3">
              <a
                href="tel:352-509-6933"
                className="block text-sm font-medium text-gray-700"
              >
                <i className="ri-phone-line mr-2"></i>
                352-509-6933
              </a>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block bg-energy-yellow text-solar-blue px-6 py-3 rounded-lg font-semibold text-sm text-center cursor-pointer whitespace-nowrap"
              >
                Free Quote
              </Link>
            </div>
          </motion.div>
        )}
      </nav>
    </header>
  );
};

export default Header;